import { connect } from 'react-redux';
import { updateProjectInfo } from '../../../actions';
import ProjectDetailView from './ProjectDetailView';

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { projects },
  } = state;

  const project = projects[ownProps.id];
  return {
    project,
  };
};

export default connect(mapStateToProps, {
  updateInfo: updateProjectInfo,
})(ProjectDetailView);
